import './DragDropFiles.css'
import React from 'react';
import { FileUploader } from "react-drag-drop-files";
import { useEffect, useState } from 'react';

function DragDropFiles(props) {

    const { upload, openDragDropPopUp, setOpenDragDropPopUp, response, currrentPath } = props
    const acceptFileTypes = ['PDF', 'DOCX', 'TXT', 'XLS', 'XLSX', 'PNG', 'JPEG']

    const [showUplaodedFilename, setShowUplaodedFilename] = useState('')

    function setShowFilteredUplaodedFilename() {
        if(response.key===null || response.key===undefined || response.key==='') {
            setShowUplaodedFilename(response.key+' uploaded successfully...')
        }
        else {
            let fullyQualifiedFilename = response.key.split('/')
            setShowUplaodedFilename(fullyQualifiedFilename[fullyQualifiedFilename.length-1]+' uploaded successfully...')
        }
    }

    useEffect(()=> {
        setShowFilteredUplaodedFilename()        
    }, [response])

    if (openDragDropPopUp === false) {
        return ''
    }
    else {
        return <div onClick={() => { setOpenDragDropPopUp(false); setShowUplaodedFilename('')}} className={openDragDropPopUp === true ? 'drag-drop' : ''}>
            <div className='drag-drop-popup'>
                <FileUploader
                    handleChange={(event) => { upload(event); setShowFilteredUplaodedFilename()}}
                    types={acceptFileTypes}
                    label='Upload or drop file right here'
                    onTypeError='ERROR UPLOADING FILE'
                    classes='file-uploader-component'
                />
                {(response.key===null || response.key===undefined || response.key==='')?'':<div className='display-uploaded-filename'>{showUplaodedFilename}</div>} 
            </div>
        </div>
    }
}

export default DragDropFiles
